import React from "react";
import { Editor } from '@tinymce/tinymce-react';
import styles from "./style.module.scss";
import cx from "classnames";

const EditorInput = (props) => {
  const { id, name = "editor", value, inputProps, onChange, onBlur, inputErrors = false } = props


  const triggerOnChange = (value, sd) => {
    if (onChange) {
      onChange(value.target.getContent());
    }
  }

  const triggerOnBlur = (e) => {
    if (onBlur) {
      e.target.name = inputProps.name;
      onBlur(e);
    }
  }

  return (
    <>
      <div className={cx(
        {
          "is-invalid form-control": inputErrors,
          [styles.errorPadding]: inputErrors,
        }
      )}>
        <Editor
          id={id}
          tinymceScriptSrc="/js/tinymce/tinymce.min.js"
          // onEditorChange={triggerOnChange}
          onChange={triggerOnChange}
          initialValue={value}
          onBlur={triggerOnBlur}
          init={{
            height: 350,
            menubar: false,
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
            ],
            toolbar:
              'undo redo | blocks | bold italic forecolor backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | code | help'
          }}
        />
      </div>
      {inputErrors}
    </>
  );
}

export default EditorInput;